/* eslint-disable react/prop-types */
import { h } from 'preact';

// This is a button that add's a specific add on to the list
const AddSingleAddon = ({ option, dispatch, btnTitle }) => {
  const addOption = () => {
    dispatch({
      type: 'ADD_AO',
      payload: option,
    });
  };

  return (
    <button
      onClick={addOption}
      className="btn btn--secondary-accent curbside_addSingleOption"
    >
      {btnTitle}
    </button>
  );
};

export default AddSingleAddon;
